import React, { Component } from "react";
import { TextareaAutosize } from "@material-ui/core";

class ModalAgregar extends Component {
  render() {
    return (
      <>
        <div>
          <fieldset className="panel">
            <div className="container">
              <div className="row">
                <div className="form-group col-md-12">
                  <label>Código:</label>
                  <span className="text-danger"> *</span>{" "}
                  <input
                    type="text"
                    name="codigo"
                    id="codigo"
                    onChange={this.props.component.handleChangeAgregar}
                    value={this.props.state.agregar.codigo}
                    className="form-control"
                    //placeholder="Código"
                    required
                    maxLength={80}
                  />
                </div>
                <div className="form-group col-lg-12">
                  <label>
                    Submeta: <span className="text-danger"> *</span>
                  </label>
                  <select
                    name="submeta_poa_id"
                    id="submeta_poa_id"
                    onChange={this.props.component.handleChangeAgregar}
                    value={this.props.state.agregar.submeta_poa_id}
                    className="form-control"
                    required
                  >
                    <option value="">Seleccione</option>
                    {this.props.state.options_submetas.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.codigo} - {option.descripcion}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-lg-12">
                  <label>
                    Descripción:
                    <span className="text-danger"> *</span>
                  </label>

                  <TextareaAutosize
                    rowsMin={3}
                    rowsMax={3}
                    name="descripcion"
                    maxLength={1000}
                    value={this.props.state.agregar.descripcion}
                    onChange={(e) =>
                      this.props.component.handleChangeAgregar(e)
                    }
                    className="form-control"
                    placeholder="Descripción"
                  />
                </div>

                <div className="form-group col-lg-6">
                  <label>UM: </label>
                  <span className="text-danger"> *</span>
                  <select
                    onChange={(e) =>
                      this.props.component.handleChangeAgregar(e)
                    }
                    name="um_id"
                    id="um_id"
                    className="form-control"
                    value={this.props.state.agregar.um_id}
                  >
                    <option className="dropdown-item"> -- Seleccione --</option>
                    {this.props.state.umCombo.map((option) => (
                      <option className="dropdown-item" value={option.id}>
                        {option.descripcion}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-lg-6">
                  <label>Fuente verificación: </label>
                  <span className="text-danger"> *</span>
                  <select
                    onChange={(e) =>
                      this.props.component.handleChangeAgregar(e)
                    }
                    name="fuente_verificacion_id"
                    id="fuente_verificacion_id"
                    className="form-control"
                    value={this.props.state.agregar.fuente_verificacion_id}
                  >
                    <option className="dropdown-item"> -- Seleccione --</option>
                    {this.props.state.fuenteCombo.map((option) => (
                      <option className="dropdown-item" value={option.id}>
                        {option.descripcion}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </fieldset>

          <div className="btn-group float-right">
            <button
              type="button"
              onClick={() => {
                this.props.component.closeModal(1);
              }}
              className="btn btn-danger"
            >
              Regresar
            </button>
            <button
              type="submit"
              className="btn btn-success btn-block"
              onClick={(e) => {
                this.props.component.handleSubmit(e, 1);
              }}
            >
              Guardar
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default ModalAgregar;
